import { createActions } from '../utils/redux';

export const {
  intakeFormSet,
  intakeFormSetFieldUploading,
  intakeFormUpdateFieldOptions,
  intakeFormUpdateFieldValue,
  intakeFormUpdateImplicitField,
  intakeFormValidate,
} = createActions('intakeForm', [
  'set',
  'setFieldUploading',
  'updateFieldOptions',
  'updateFieldValue',
  'updateImplicitField',
  'validate',
]);
